<template>
  <div id="report-content" class="main-content">
    <the-header :title="t('Report')" :buttons="headerButtons" @button-print="print()"/>
    <loading v-if="loading === true"/>
    <template v-if="loading === false">
      <div class="row">
        <div class="col col-6 col-sm-6 col-md-3">
          <dashboard-card :value="doctors"
                          :text="t('Doctors')"
          />
        </div>
        <div class="col col-6 col-sm-6 col-md-3">
          <dashboard-card :value="patients"
                          :text="t('Patients')"
                          card-class="bg-success"
          />
        </div>
        <div class="col col-12 col-sm-12 col-md-3">
          <dashboard-card :value="applications"
                          :text="t('Applications')"
                          card-class="bg-warning"
          />
        </div>
        <div class="col col-12 col-sm-12 col-md-3">
          <dashboard-card :value="repeat"
                          :text="t('Repeat')"
                          card-class="bg-danger"
          />
        </div>
      </div>

      <h2 class="h2">{{t('Applications by status')}}</h2>
      <div class="card">
        <div class="card-body">
          <graph ref="applicationStatus"
                 :options="applicationStatus.options"
                 :chart-data="applicationStatus.chartData"
                 type="line"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <h2 class="h2">{{t('Doctors by activity')}}</h2>
          <div class="card">
            <div class="card-body">
              <graph ref="doctor"
                     :options="doctor.options"
                     :chart-data="doctor.chartData"
                     type="pie"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <h2 class="h2">{{t('Applications by status')}}</h2>
          <div class="card">
            <div class="card-body">
              <graph ref="applicationsStatusGlobal"
                     :options="applicationsStatusGlobal.options"
                     :chart-data="applicationsStatusGlobal.chartData"
                     type="pie"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <h2 class="h2">{{t('Regions by activity')}}</h2>
          <div class="card">
            <div class="card-body">
              <graph ref="doctor"
                     :options="regions.options"
                     :chart-data="regions.chartData"
                     type="pie"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <h2 class="h2">{{t('Inactive by regions')}}</h2>
          <div class="card">
            <div class="card-body">
              <graph ref="applicationsStatusGlobal"
                     :options="regionsInactive.options"
                     :chart-data="regionsInactive.chartData"
                     type="pie"
              />
            </div>
          </div>
        </div>
      </div>

      <h2 class="h2">{{t('App activity')}}</h2>
      <div class="card">
        <div class="card-body">
          <graph ref="appActivity"
                 :options="appActivity.options"
                 :chart-data="appActivity.chartData"
                 type="bar"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader';
    import DashboardCard from '../../../admin/Components/Dashboard/DashboardCard';
    import VueChart from 'vue-chart-js'
    import Graph from "./graph";
    import Loading from '../../../core/Components/loading';
    import ChartDataLabels from 'chartjs-plugin-datalabels';

    export default {
        components: {
            Loading,
            Graph,
            DashboardCard,
            TheHeader,
            VueChart,
            ChartDataLabels
        },
        created() {
            this.loadData();
            window.addEventListener('afterprint', this.reloadAfterPrint)
        },
        methods: {
            print() {
                this.$refs.applicationStatus.renderImage();
                this.$refs.doctor.renderImage();
                this.$refs.applicationsStatusGlobal.renderImage();
                this.$refs.appActivity.renderImage();
                window.print();
            },
            reloadAfterPrint() {
                this.$refs.applicationStatus.renderGraph();
                this.$refs.doctor.renderGraph();
                this.$refs.applicationsStatusGlobal.renderGraph();
                this.$refs.appActivity.renderGraph();
            },
            loadData() {
                this.loading = true;
                this.$store.dispatch('reports/report').then((data) => {
                    this.loading = false;
                    this.applications = data.applications;
                    this.repeat = Math.round((data.repeatsApplication / data.applications) * 100) + '%';
                    this.doctors = data.doctors;
                    this.patients = data.patients;

                    // Status
                    this.applicationStatus.chartData.labels = data.applicationStatus.labels;
                    this.applicationStatus.chartData.datasets[0].data = data.applicationStatus.values.accepted;
                    this.applicationStatus.chartData.datasets[1].data = data.applicationStatus.values.declined;

                    // Status global
                    this.applicationsStatusGlobal.chartData.datasets[0].data.push(data.acceptedApplication);
                    this.applicationsStatusGlobal.chartData.datasets[0].data.push(data.declinedApplication);
                    this.applicationsStatusGlobal.chartData.datasets[0].data.push(data.otherApplication);

                    // Doctor
                    this.doctor.chartData.datasets[0].data.push(data.activeDoctors);
                    this.doctor.chartData.datasets[0].data.push(data.inactiveDoctors);

                    // Regions
                    this.regions.chartData.datasets[0].data.push(data.regions.all.BL);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.TA);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.TC);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.NI);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.ZI);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.BC);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.PV);
                    this.regions.chartData.datasets[0].data.push(data.regions.all.KI);

                    // RegionsInactive
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.BL);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.TA);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.TC);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.NI);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.ZI);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.BC);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.PV);
                    this.regionsInactive.chartData.datasets[0].data.push(data.regions.inactive.KI);

                    // App status
                    this.appActivity.chartData.labels = data.activity.labels;
                    this.appActivity.chartData.datasets[0].data = data.activity.doctor;
                    this.appActivity.chartData.datasets[1].data = data.activity.login;
                    this.appActivity.chartData.datasets[2].data = data.activity.inactive;
                    this.appActivity.chartData.datasets[3].data = data.activity.patient;
                    this.appActivity.chartData.datasets[4].data = data.activity.application;
                });
            }
        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'button',
                        key: 'print',
                        name: this.t('Print'),
                        icon: 'print',
                        styleClass: 'btn-primary'
                    }
                ],
                loading: true,
                applications: 0,
                repeat: 0,
                doctors: 0,
                patients: 0,
                regions: {
                    options: {
                        layout: {
                            padding: {
                                bottom: 25,
                                top: 25,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        legend: {
                            position: 'right',
                            boxWidth: 80
                        }
                    },
                    chartData: {
                        labels: [
                            this.t('Bratislavský'),
                            this.t('Trnavský'),
                            this.t('Trenčiansky'),
                            this.t('Nitriansky'),
                            this.t('Žilinský'),
                            this.t('Banskobystrický'),
                            this.t('Prešovský'),
                            this.t('Košický')
                        ],
                        datasets: [
                            {
                                backgroundColor: [
                                    '#009DFA',
                                    '#dc3545',
                                    '#3ac165',
                                    '#ffc107',
                                    '#17a2b8',
                                    '#b82aa5',
                                    '#b87800',
                                    '#0002b8',
                                ],
                                data: [],
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '15',
                                        weight: 'bold'
                                    },
                                    align: 'end',
                                    anchor: 'end',
                                    padding: 0,
                                    clamp: true,
                                    formatter: function (value, context) {
                                        let number = context.dataset.data.reduce((a, b) => a + b, 0);
                                        number = (value / number) * 100;
                                        return Math.round(number) + '%';
                                    }
                                }
                            }
                        ]
                    }
                },
                regionsInactive: {
                    options: {
                        layout: {
                            padding: {
                                bottom: 25,
                                top: 25,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        legend: {
                            position: 'right',
                            boxWidth: 80
                        }
                    },
                    chartData: {
                        labels: [
                            this.t('Bratislavský'),
                            this.t('Trnavský'),
                            this.t('Trenčiansky'),
                            this.t('Nitriansky'),
                            this.t('Žilinský'),
                            this.t('Banskobystrický'),
                            this.t('Prešovský'),
                            this.t('Košický')
                        ],
                        datasets: [
                            {
                                backgroundColor: [
                                    '#009DFA',
                                    '#dc3545',
                                    '#3ac165',
                                    '#ffc107',
                                    '#17a2b8',
                                    '#b82aa5',
                                    '#b87800',
                                    '#0002b8',
                                ],
                                data: [],
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '15',
                                        weight: 'bold'
                                    },
                                    align: 'end',
                                    anchor: 'end',
                                    padding: 0,
                                    clamp: true,
                                }
                            }
                        ]
                    }
                },
                doctor: {
                    options: {
                        layout: {
                            padding: {
                                bottom: 25,
                                top: 25,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        legend: {
                            position: 'right',
                            boxWidth: 80
                        }
                    },
                    chartData: {
                        labels: [this.t('Active'), this.t('Inactive')],
                        datasets: [
                            {
                                backgroundColor: ['#3ac165', '#dc3545'],
                                data: [],
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '15',
                                        weight: 'bold'
                                    },
                                    align: 'end',
                                    anchor: 'end',
                                    clamp: true,
                                    formatter: function (value, context) {
                                        let number = context.dataset.data.reduce((a, b) => a + b, 0);
                                        number = (value / number) * 100;
                                        return Math.round(number) + '%';
                                    }
                                }
                            }
                        ]
                    }
                },
                applicationsStatusGlobal: {
                    options: {
                        layout: {
                            padding: {
                                bottom: 25,
                                top: 25,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        legend: {
                            position: 'right',
                            boxWidth: 80
                        }
                    },
                    chartData: {
                        labels: [this.t('Accepted'), this.t('Declined'), this.t('Other applicant')],
                        datasets: [
                            {
                                backgroundColor: ['#3ac165', '#dc3545', '#ffc107'],
                                data: [],
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '15',
                                        weight: 'bold'
                                    },
                                    align: 'end',
                                    anchor: 'end',
                                    padding: 0,
                                    offset: 1,
                                    clamp: true,
                                    formatter: function (value, context) {
                                        let number = context.dataset.data.reduce((a, b) => a + b, 0);
                                        number = (value / number) * 100;
                                        return Math.round(number) + '%';
                                    }
                                }
                            }
                        ]
                    }
                },
                applicationStatus: {
                    options: {
                        responsive: true,
                        scales: {
                            xAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: this.t('Time')
                                }
                            }],
                            yAxes: [{
                                gridLines: {},
                                scaleLabel: {
                                    display: true,
                                    labelString: this.t('Amount')
                                }
                            }]
                        }
                    },
                    chartData: {
                        labels: [],
                        datasets: [
                            {
                                backgroundColor: '#3ac165',
                                borderColor: '#3ac165',
                                label: this.t('Accepted'),
                                data: [100, 500, 5000],
                                fill: false,
                                datalabels: {
                                    display: false
                                }
                            }, {
                                backgroundColor: '#dc3545',
                                borderColor: '#dc3545',
                                label: this.t('Declined'),
                                data: [10, 2000, 0],
                                fill: false,
                                datalabels: {
                                    display: false
                                }
                            }
                        ]
                    }
                },
                appActivity: {
                    options: {
                        responsive: true,
                        scales: {
                            xAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: this.t('Time')
                                }
                            }],
                            yAxes: [{
                                gridLines: {},
                                scaleLabel: {
                                    display: true,
                                    labelString: this.t('Amount')
                                }
                            }]
                        }
                    },
                    chartData: {
                        labels: [],
                        datasets: [
                            {
                                backgroundColor: '#009DFA',
                                borderColor: '#009DFA',
                                label: this.t('Registered Doctors'),
                                data: [100, 500, 800],
                                fill: false,
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '12',
                                        weight: 'bold'
                                    },
                                    align: 'center',
                                    clamp: true,
                                }
                            }, {
                                backgroundColor: '#17a2b8',
                                borderColor: '#17a2b8',
                                label: this.t('Active doctors'),
                                data: [100, 500, 800],
                                fill: false,
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '12',
                                        weight: 'bold'
                                    },
                                    clamp: true,
                                    align: 'center'
                                }
                            }, {
                                backgroundColor: '#dc3545',
                                borderColor: '#dc3545',
                                label: this.t('Inactive doctors'),
                                data: [100, 500, 800],
                                fill: false,
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '12',
                                        weight: 'bold'
                                    },
                                    clamp: true,
                                    align: 'center'
                                }
                            }, {
                                backgroundColor: '#3ac165',
                                borderColor: '#3ac165',
                                label: this.t('Patients'),
                                data: [100, 2000, 200],
                                fill: false,
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '12',
                                        weight: 'bold'
                                    },
                                    clamp: true,
                                    align: 'center'
                                }
                            }, {
                                backgroundColor: '#ffc107',
                                borderColor: '#ffc107',
                                label: this.t('Applications'),
                                data: [400, 2000, 400],
                                fill: false,
                                datalabels: {
                                    color: '#3b3b3b',
                                    font: {
                                        size: '12',
                                        weight: 'bold'
                                    },
                                    align: 'center',
                                    clamp: true
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
</script>
<style lang="scss">
  @media print {
    body.bg-light {
      padding-top: 0;
      background: #fff ! important;
    }
    #main-footer,
    #mainMenu {
      display: none;
    }

    #main-header {
      > div:nth-child(2) {
        display: none;
      }
    }

    .container {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/report/report.vue